<template>
  <el-card class="mat12">
    <div class="box_cost">
      <p>
        <img src="@/assets/money.png" alt />
        <span>收入：</span>
      </p>
      <el-table
        :data="items1"
        style="width: 380px"
        border
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column prop="title" label="收入项" width="200" label-class-name="boldFont"></el-table-column>
        <el-table-column prop="cost" label="价钱" label-class-name="boldFont">
          <template slot-scope="scope">
            <span class="red">{{scope.row.cost}} 元</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="box_cost">
      <p>
        <img src="@/assets/money.png" alt />
        <span>支出：</span>
      </p>
      <el-table
        :data="items2"
        style="width: 380px"
        border
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column prop="title" label="支出项" width="200" label-class-name="boldFont"></el-table-column>
        <el-table-column prop="cost" label="价钱" label-class-name="boldFont">
          <template slot-scope="scope">
            <span class="red">{{scope.row.cost}} 元</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'CardProcessMoney',
  props: {
    dataDesc: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      items1: [],
      items2: []
    }
  },
  created () {
    this.dataDesc.items.map(item => {
      // 处理直入直出
      if (item.type == 1) {
        this.items1.push(item)
      } else {
        this.items2.push(item)
      }
    })
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
          sums[index] += ' 元'
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #409eff;
$red_color: #ff0000;
.red {
  color: $red_color;
}

.box_cost {
  padding-left: 10px;
  p {
    display: flex;
    align-items: center;
    padding: 20px 0 20px;
  }
  p > img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  p > span {
    color: #001111;
    font-size: 15px;
    font-weight: bold;
  }
}
</style>

<style lang="scss">
.el-table__footer-wrapper {
  .has-gutter {
    tr {
      td {
        &:nth-child(2) {
          .boldFont {
            color: #ff0000;
            font-weight: 400;
          }
        }
      }
    }
  }
}
.boldFont {
  color: #001111;
  font-weight: bold;
}
</style>
